/**
 * Supervisao do setor.
 *
 * Restrita a quem tem papel de supervisor na API -- a tela existe para todos
 * no menu apenas quando a permissao da plataforma permite, mas quem manda e o
 * 403 da API: a permissao de tela e conveniencia, a barreira e la.
 */
export const nav = {
    permissao: 'atendimento.supervisao:ver',
    section: 'Atendimento',
    title: 'Supervisao',
    icon: 'monitoring',
    route: '/supervisao',
    sequence: 2,
};

export default [
    {
        path: '/supervisao',
        name: 'supervisao',
        component: () => import('./pages/SupervisaoPage.vue'),
        meta: { requiresAuth: true, permissao: 'atendimento.supervisao:ver' },
    },
];
